import React from 'react'

export default () => (
  <svg
    viewBox="0 0 514 426"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
  >
    <path
      d="M438.507 48.592c29.29 36.93 14.998 113.337-3.962 166.821-18.96 53.344-42.872 83.623-61.974 116.733-19.102 33.11-33.393 68.908-60.135 84.33-26.6 15.565-65.512 10.612-89.849-9.055-24.478-19.668-34.524-54.051-75.275-88.434-40.608-34.242-111.921-68.342-123.1-106.97-11.177-38.627 37.78-81.642 87.727-115.176 49.947-33.392 100.885-57.022 162.718-70.04 61.833-13.017 134.56-15.28 163.85 21.791z"
      fill="#e5f2ff"
      fillRule="nonzero"
    />
    <path
      d="M419.434 252.5c22.28-3.935 40.68-7.191 40.891-7.236l.385-.082-21.034-25.018c-11.568-13.76-21.033-25.072-21.033-25.137 0-.124 21.719-59.932 21.84-60.145.042-.071 14.822 25.447 35.829 61.857l36.033 62.456.274.479-66.846-.009-66.845-.008 40.506-7.156zm-80.222-7.629c0-.035 9.91-17.24 22.024-38.231l22.024-38.168 25.666-21.54c14.117-11.846 25.705-21.553 25.751-21.571.047-.018-.139.45-.412 1.039l-27.87 59.778-27.373 58.708-19.905.025c-10.948.013-19.905-.004-19.905-.04z"
      fill="#0089d6"
      fillRule="nonzero"
    />
    <g fillRule="nonzero">
      <path
        d="M374.39 34.513h5.307l15.128-13.536.741-5.75c-28.155-22.239-71.126-19.836-95.98 5.357-6.906 6.993-11.91 15.322-14.647 24.334a9.091 9.091 0 015.307-.28l30.256-4.47s1.536-2.28 2.34-2.14c13.456-13.228 36.106-14.77 51.652-3.515h-.105z"
        fill="#ea4335"
      />
      <path
        d="M416.378 44.918c-3.48-11.461-10.615-21.763-20.54-29.634l-21.23 18.995c8.965 6.553 14.074 16.435 13.854 26.792v3.375c10.437 0 18.9 7.572 18.9 16.911 0 9.339-8.463 16.911-18.9 16.911h-37.799l-3.771 3.422v20.285l3.771 3.375h37.8c27.141.187 49.321-19.35 49.53-43.638.126-14.751-7.992-28.55-21.615-36.794z"
        fill="#4285f4"
      />
      <path
        d="M312.812 125.135h37.8V98.062h-37.8c-2.695 0-5.349-.523-7.804-1.523l-5.307 1.477-15.232 13.536-1.327 4.749c8.535 5.777 18.962 8.88 29.67 8.834z"
        fill="#34a853"
      />
      <path
        d="M312.812 37.317c-27.152.14-49.019 19.95-48.862 44.246.094 13.564 7.167 26.334 19.192 34.598l21.919-19.613c-9.508-3.842-13.739-13.863-9.445-22.37 4.294-8.507 15.494-12.293 25-8.451 4.19 1.692 7.544 4.702 9.445 8.45l21.919-19.612c-9.32-10.919-23.82-17.304-39.168-17.248z"
        fill="#fbbc05"
      />
    </g>
    <path
      d="M49.468 205.573c0 2.118.23 3.836.63 5.096a30.646 30.646 0 001.832 4.122c.286.458.4.916.4 1.317 0 .572-.343 1.145-1.087 1.717l-3.607 2.405c-.515.344-1.03.515-1.489.515-.572 0-1.145-.286-1.717-.801a17.713 17.713 0 01-2.061-2.691 44.322 44.322 0 01-1.775-3.378c-4.466 5.267-10.077 7.901-16.833 7.901-4.81 0-8.646-1.374-11.451-4.122-2.805-2.749-4.237-6.413-4.237-10.993 0-4.867 1.718-8.817 5.21-11.795 3.493-2.977 8.13-4.465 14.028-4.465 1.946 0 3.95.171 6.069.458 2.118.286 4.294.744 6.584 1.26v-4.18c0-4.352-.916-7.386-2.691-9.161-1.832-1.775-4.924-2.634-9.333-2.634a26.05 26.05 0 00-6.183.745c-2.118.515-4.18 1.145-6.183 1.946-.917.401-1.604.63-2.004.745-.401.114-.687.171-.916.171-.802 0-1.203-.572-1.203-1.775v-2.805c0-.916.115-1.603.401-2.004.286-.4.802-.802 1.603-1.202 2.004-1.03 4.409-1.89 7.214-2.577 2.806-.744 5.783-1.088 8.932-1.088 6.813 0 11.794 1.546 15 4.638 3.15 3.092 4.753 7.787 4.753 14.085v18.55h.114zm-23.245 8.703c1.89 0 3.836-.344 5.897-1.03 2.061-.688 3.893-1.948 5.44-3.665.915-1.088 1.602-2.29 1.946-3.664.343-1.375.572-3.035.572-4.982v-2.404c-1.66-.401-3.435-.745-5.267-.974a43.142 43.142 0 00-5.382-.343c-3.836 0-6.641.744-8.53 2.29-1.89 1.546-2.806 3.722-2.806 6.584 0 2.691.687 4.695 2.118 6.07 1.374 1.43 3.378 2.118 6.012 2.118zm45.975 6.183c-1.03 0-1.718-.172-2.176-.572-.458-.344-.858-1.145-1.202-2.233l-13.455-44.258c-.343-1.145-.515-1.89-.515-2.29 0-.916.458-1.431 1.374-1.431h5.611c1.088 0 1.832.171 2.233.572.458.344.802 1.145 1.145 2.233l9.619 37.902 8.931-37.902c.287-1.145.63-1.89 1.088-2.233.458-.343 1.26-.572 2.29-.572h4.58c1.089 0 1.833.171 2.291.572.458.344.859 1.145 1.088 2.233l9.046 38.36 9.905-38.36c.344-1.145.744-1.89 1.145-2.233.458-.343 1.203-.572 2.233-.572h5.325c.916 0 1.431.458 1.431 1.43 0 .287-.057.573-.114.917-.058.343-.172.802-.401 1.431l-13.798 44.258c-.344 1.145-.745 1.89-1.203 2.233-.458.343-1.202.572-2.176.572h-4.923c-1.088 0-1.833-.171-2.29-.572-.459-.4-.86-1.145-1.088-2.29l-8.875-36.93-8.817 36.872c-.286 1.146-.63 1.89-1.088 2.29-.458.401-1.26.573-2.29.573h-4.924zm73.572 1.546c-2.977 0-5.954-.343-8.817-1.03-2.863-.688-5.096-1.432-6.584-2.29-.916-.516-1.546-1.089-1.775-1.604a4.041 4.041 0 01-.344-1.603v-2.92c0-1.202.458-1.775 1.317-1.775.344 0 .687.057 1.03.172.344.114.86.343 1.432.572a31.143 31.143 0 006.298 2.004c2.29.458 4.523.687 6.813.687 3.607 0 6.413-.63 8.36-1.889 1.946-1.26 2.977-3.092 2.977-5.44 0-1.602-.516-2.92-1.546-4.007-1.03-1.088-2.978-2.061-5.783-2.977l-8.302-2.577c-4.18-1.316-7.271-3.263-9.16-5.84-1.89-2.519-2.863-5.324-2.863-8.301 0-2.405.515-4.524 1.546-6.356 1.03-1.832 2.404-3.435 4.122-4.695 1.718-1.316 3.664-2.29 5.954-2.977 2.29-.687 4.695-.973 7.214-.973 1.26 0 2.577.057 3.836.229 1.317.172 2.52.4 3.722.63 1.145.286 2.233.572 3.263.916 1.031.343 1.833.687 2.405 1.03.802.458 1.374.916 1.718 1.432.343.458.515 1.088.515 1.89v2.69c0 1.202-.458 1.832-1.317 1.832-.458 0-1.202-.229-2.175-.687-3.264-1.488-6.928-2.233-10.993-2.233-3.264 0-5.84.516-7.615 1.603-1.775 1.088-2.691 2.749-2.691 5.096 0 1.603.572 2.977 1.718 4.065 1.145 1.088 3.263 2.176 6.298 3.15l8.13 2.576c4.122 1.316 7.1 3.148 8.874 5.496 1.775 2.347 2.634 5.038 2.634 8.016 0 2.461-.515 4.694-1.489 6.641-1.03 1.947-2.404 3.664-4.18 5.038-1.774 1.432-3.893 2.462-6.355 3.207-2.576.801-5.267 1.202-8.187 1.202z"
      fill="#252f3e"
      fillRule="nonzero"
    />
    <g fill="#f90">
      <path d="M156.591 249.83c-18.837 13.913-46.204 21.3-69.736 21.3-32.978 0-62.693-12.196-85.137-32.464-1.775-1.603-.172-3.779 1.947-2.52 24.275 14.085 54.22 22.616 85.194 22.616 20.898 0 43.857-4.351 64.984-13.283 3.149-1.431 5.84 2.061 2.748 4.352z" />
      <path d="M164.435 240.899c-2.405-3.092-15.917-1.489-22.043-.744-1.832.229-2.118-1.374-.458-2.577 10.764-7.557 28.455-5.382 30.517-2.862 2.06 2.576-.573 20.268-10.65 28.741-1.546 1.317-3.034.63-2.347-1.088 2.29-5.668 7.386-18.436 4.98-21.47z" />
    </g>
    <path
      d="M1.081.28a.732.732 0 01-.245.31C.57.794.182.905.063.883A.116.116 0 01.045.879C-.057.847-.065.716-.065.387v-.793s-.024-.348.122-.428a.217.217 0 01.054-.021c.159-.04.426.048.653.226.185.145.29.242.333.427.017.069.024.15.024.251a.64.64 0 01-.04.231z"
      fill="url(#prefix___Linear1)"
      fillRule="nonzero"
      transform="matrix(0 -153.708 -122.16 0 256.701 340.875)"
    />
    <path
      d="M155.911 311.488c15.259-23.995 20.055-57.286 24.296-91.072l13.25 68.71h114.839l21.102-68.71c-.497 32.113 3.908 63.606 19.14 93.736 0 0-75.09 84.974-192.627-2.664"
      fill="#1f395e"
      fillRule="nonzero"
      opacity={0.22}
    />
    <path
      d="M289.415 185.391c-1.238 16.519-4.375 34.265-37.647 34.265-35.07 0-41.11-19.705-42.64-33.693 7.357-6.803 10.416-8.546 15.318-10.908 9.22-4.444 17.677-5.106 24.2-6.19 17.787-2.96 28.953.587 41.254 7.776"
      fill="#1f395e"
      fillRule="nonzero"
    />
    <path
      d="M323.401 350.865H188.685a5.888 5.888 0 110-11.776h134.716a5.89 5.89 0 110 11.776"
      fill="#151515"
      fillRule="nonzero"
    />
    <path
      d="M1.188.375a.063.063 0 01-.028.091L.443.777-.188-.225l.566-.499.02-.017a.063.063 0 01.095.013L1.188.375z"
      fill="url(#prefix___Linear2)"
      fillRule="nonzero"
      transform="scale(-116.0076 116.0076) rotate(-57.789 1.356 3.719)"
    />
    <path
      d="M339.212 252.677l-13.956 86.425h-136.57l46.289-4.828c47.524-4.918 88.013-36.662 104.237-81.597"
      fill="#626262"
      fillRule="nonzero"
    />
    <path
      d="M251.207 207.143h-.912c-5.3 0-9.689-1.09-13.25-2.68-8.658-3.887-13.9-12.926-13.694-22.407.03-.973.03-1.915.03-2.857.029-7.861-.472-14.398-.472-14.398v-3.535l49.47-2.207c.176 7.126 1 13.455 1.973 18.52.028.09.028.148.059.236 2.827 14.87-8.068 28.946-23.204 29.328M289.491 134.009s5.976-9.639 12.145-4.6c6.169 5.038-.381 30.236-16.769 25.852l4.624-21.252zM208.277 134.009s-5.976-9.639-12.144-4.6c-6.169 5.038.381 30.236 16.769 25.852l-4.625-21.252z"
      fill="#e9bfa8"
      fillRule="nonzero"
    />
    <path
      d="M291.012 130.89c0 29.143-25.697 52.768-42.155 52.768-17.716 0-42.155-23.625-42.155-52.767 0-33.885 18.874-52.767 42.155-52.767 23.281 0 42.155 18.444 42.155 52.767z"
      fill="#f5d6bc"
      fillRule="nonzero"
    />
    <g>
      <path
        d="M273.752 94.98s-17.842 23.128-60.793 21.145l-2.974 28.744s-1.652-15.784-10.573-16.445c0 0-12.224-60.206 30.397-70.45 42.621-10.241 53.194 14.208 53.194 14.208s14.537 4.956 16.19 23.789c1.651 18.833 0 32.71 0 32.71s-10.574 3.303-12.226 16.188c0 0 0-29.735-2.808-38.986-2.808-9.252-10.407-10.904-10.407-10.904z"
        fill="#ac4d00"
        fillRule="nonzero"
      />
    </g>
    <defs>
      <linearGradient
        id="prefix___Linear1"
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1 0 0 -1 0 .01)"
      >
        <stop offset={0} stopColor="#1f3a65" />
        <stop offset={1} stopColor="#294a7a" />
      </linearGradient>
      <linearGradient
        id="prefix___Linear2"
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1 0 0 -1 0 .01)"
      >
        <stop offset={0} />
        <stop offset={1} stopColor="#9d9d9d" />
      </linearGradient>
    </defs>
  </svg>
);
